// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZFlD","colMin":"styles_colMin__1nW0U"};